import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { SITE } from "../lib/site";

const NAV = [
  { to: "/", label: "Accueil" },
  { to: "/depannage", label: "Dépannage" },
  { to: "/installation", label: "Installation" },
  { to: "/zone", label: "Zone" },
  { to: "/a-propos", label: "À propos" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-black/5"
    >
      <div className="container-x flex items-center justify-between h-20">
        {/* Logo */}
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-3 group"
          onClick={() => setOpen(false)}
        >
          <img
            src="/voltis-mark.svg"
            alt=""
            aria-hidden="true"
            className="w-10 h-10 group-hover:scale-105 transition-transform"
          />
          <div className="leading-tight">
            <div className="font-heading font-extrabold text-xl text-slate-900 tracking-tight">
              VOLTIS<span className="text-[#EAB308]">.</span>
            </div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500 font-semibold">
              Électricité
            </div>
          </div>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className={({ isActive }) =>
                `nav-link text-sm font-medium tracking-wide ${
                  isActive ? "text-slate-900 active" : "text-slate-600 hover:text-slate-900"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        {/* Call CTA */}
        <a
          href={`tel:${SITE.phoneTel}`}
          data-testid="header-call-btn"
          className="hidden sm:inline-flex items-center gap-2 bg-[#0F172A] text-white px-5 py-3 hover:bg-[#1E293B] transition-colors text-sm font-semibold rounded-sm"
        >
          <Phone className="w-4 h-4" />
          <span>{SITE.phoneDisplay}</span>
        </a>

        {/* Mobile menu button */}
        <button
          data-testid="mobile-menu-btn"
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 text-slate-900"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-slate-100 bg-white">
          <nav className="container-x py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                className={({ isActive }) =>
                  `py-3 px-2 text-base font-medium border-l-2 transition-colors ${
                    isActive
                      ? "border-[#EAB308] text-slate-900 bg-yellow-50/60"
                      : "border-transparent text-slate-600 hover:text-slate-900"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <a
              href={`tel:${SITE.phoneTel}`}
              data-testid="mobile-call-btn"
              className="mt-3 inline-flex items-center justify-center gap-2 bg-[#0F172A] text-white px-5 py-3 text-sm font-semibold rounded-sm"
            >
              <Phone className="w-4 h-4" /> {SITE.phoneDisplay}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
